import { render } from "./ContentImageUploadNew.vue?vue&type=template&id=f02a4fe4"
import script from "./ContentImageUploadNew.vue?vue&type=script&lang=js"
export * from "./ContentImageUploadNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__